/** @jsx jsx */
import { jsx } from '@emotion/core'
// import styled from '@emotion/styled'
import React, { useState, useContext } from 'react'
import {
  modifierCol,
  modifiedDateCol,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { dateCol, strCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  deleteFuelCosts,
  saveFuelCosts,
  // getPFuelUnitsAtFuelCosts,
  // getFuelCosts,
  getAuthorization,
  getCredentials,
  getFuelCostsBySystemModifier,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
// import { CriteriaRow, Filler } from 'core/screen-util'
import {
  Button,
  // DatePicker,
  // Checkbox,
  // InputNumber,
  // Select,
  message,
  Icon,
  Upload,
} from 'antd'

import { ErrorContext, PNodeZoneContext } from 'context'
import * as Actions from 'core/EventActions'
import CommonScreen from 'admin/component/CommonScreen'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

const title = 'Fuel Price Promod'

const FuelCostheaders = [
  unitIdHeader,
  // strCol({
  //   ident: 'unitId',
  //   display: 'Unit Id',
  //   isKey: true,
  //   sortOrder: 'asc',
  // }),
  dateCol({
    ident: 'effectivedate',
    display: 'Effectivedate',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'pFuelCode',
    display: 'Primary Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(pFuelCodeChioce),
  }),
  numCol({
    ident: 'fuelCost',
    display: 'Fuel Cost',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

// eslint-disable-next-line no-unused-vars
const FuelCostsPromod = ({
  targetInfo,
  envConfig,
  actionPermits,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)
  const { setError } = useContext(ErrorContext)

  const [showMessages, setShowMessages] = useState(false)
  const [messages, setMessages] = useState([])

  // const [unitlist, setUnitList] = useState([])

  // useEffect(
  //   _ => {
  //     getPFuelUnitsAtFuelCosts(targetInfo).fork(setError, data => {
  //       setUnitList(data)
  //     })
  //   },
  //   [envConfig.clientId, setError, targetInfo]
  // )

  const withCriteria = (state, props, selectedUnits, selectedDate) => {
    return {
      date: selectedDate.format('YYYY-MM-DD'),
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => e.emktId)
        .filter(e => e),
    }
  }

  const fileProps = {
    name: 'file',
    action: `${targetInfo.baseUrl}/interface-data/marginanalysis-fuelcostpromod`,
    method: 'POST',
    data: { importType: 'json' },
    headers: getAuthorization(targetInfo),
    ...getCredentials(targetInfo),
  }

  const disableImport = !hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [
      Actions.MARGIN_ANALYSIS_ADMIN,
      Actions.MARGIN_ANALYSIS_CORE_WRITE,
    ],
    matchAny: true,
  })

  const { marginUnitsList, emktIdUnitNameMap } = useContext(PNodeZoneContext)

  const headerWithFormatter = FuelCostheaders.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,

          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  const extraCriteriaAfterButton = _ => (
    <React.Fragment>
      <Upload
        {...fileProps}
        onChange={data => {
          if (
            data.file.response &&
            data.file.response.restfulStatus &&
            data.file.response.restfulStatus === 'FAILURE'
          ) {
            // setShowMessages(true)
            // setMessages([data.file.response])
            setError(data.file.response)
          } else if (data.file.response && data.file.response.length === 0) {
            //  if (data.file.response) {
            message.success('File imported successfully')
            // }
          } else if (data.file.response && data.file.response.length > 0) {
            setShowMessages(true)
            setMessages(data.file.response)
            //  if (data.file.response) {
            // message.success('File imported successfully')
            // }
          }
        }}
        multiple={false}
        showUploadList={false}
      >
        <Button disabled={disableImport} type="primary">
          <Icon type="upload" /> Import
        </Button>
      </Upload>
    </React.Fragment>
  )

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  return (
    <div>
      <CommonScreen
        // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        withUnitSelection
        extraUnitSelectionProps={extraUnitSelectionProps}
        withoutModify
        withDelete={false}
        allowInsert={false}
        isEditableGrid={false}
        extraCriteriaAfterButton={extraCriteriaAfterButton}
        withDatePickerTitle="Effective Date : "
        autoRetrieve={false}
        isAdminScreen={false}
        withCriteria={withCriteria}
        withDatePicker
        title={title}
        header={headerWithFormatter}
        saveTask={saveFuelCosts}
        retrieveTask={getFuelCostsBySystemModifier}
        deleteTask={deleteFuelCosts}
        altBy={u => u.pFuelCode}
        sortOptions={FuelCostheaders}
        initialSortOptions={FuelCostheaders}
        widthOffset={50}
        insertComp={false}
        insertCompHeight={10}
        onInsertEvent={_ => _}
      />
      {showMessages && (
        <JcTmpErrorDialog
          errors={messages}
          visible={showMessages}
          closeErrorPrompt={_ => setShowMessages(false)}
          title="Error/Warning"
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(FuelCostsPromod)
